import { render, staticRenderFns } from "./vCard.vue?vue&type=template&id=4f6d711c&"
import script from "./vCard.vue?vue&type=script&lang=js&"
export * from "./vCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports